export enum StateType {
	Inactive = 0,
	Active = 1,
	Hidden = 2
}